/* @flow */

import getConfig from 'next/config';

import * as React from 'react';
import styled from 'styled-components';
import metaInfo from '../../config/metaInfo';

import { Link } from '../../routes';
import FlexBox from '../FlexBox';

const {
  publicRuntimeConfig: { logoLinkHref: LOGO_LINK_HREF },
} = getConfig();

const { brands } = metaInfo;

const StyledLogo = styled(FlexBox)`
  border-radius: 6px;
  cursor: pointer;
  a {
    line-height: 100%;
  }
  img {
    width: ${({ locale, size }) => locale === 'cn' ? size.cnWidth : size.enWidth};
    vertical-align: middle;
  }

  h1 {
    margin: 0;
    line-height: 0.8;
  }

  h1 a,
  h1 a:hover,
  h1 a:active,
  h1 a:visited {
    color: #f3bb2e;
  }
`;

export type Props = { locale: string, size?: Object };

const Logo = (props: Props) => {
  const { locale, size } = props;

  const logoSrc = locale === 'cn' ? require('./logo-cn.svg') : require('./logo-en.svg');
  return (
    <StyledLogo locale={locale} size={size} justify="center" direction="column">
      <Link route={LOGO_LINK_HREF.replace('%locale', locale)} prefetch={true}>
        <a draggable={false} id="exchange-header-logo">
          <img
            /* eslint-disable-next-line */
            src={logoSrc}
            alt={brands[locale]}
            draggable={false}
          />
        </a>
      </Link>
    </StyledLogo>
  );
};

Logo.defaultProps = {
  size: {
    cnWidth: '70px',
    enWidth: '160px',
  },
};

export default Logo;
